import React, { useState } from 'react';
import PasswordMask from 'react-password-mask';

import Styles from './PasswordInput.module.scss';

interface OwnProps {
  className?: string;
}

type Props = OwnProps & React.HTMLProps<HTMLInputElement>;

const PasswordInput: React.FC<Props> = props => {
  const [isShown, setIsShown] = useState(false);
  const { className } = props;

  const handleToggle = () => {
    setIsShown(prevState => !prevState);
  };

  return (
    <PasswordMask
      {...props}
      className={''}
      inputClassName={[className, Styles.passwordInput].join(' ')}
      buttonClassName={isShown ? Styles.passwordShow : Styles.passwordHidden}
      hideButtonContent={' '}
      showButtonContent={' '}
      onToggle={handleToggle}
    />
  );
};

export default PasswordInput;
